// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__y3jH4","description":"NotFound_description__SCYdR","btnContainer":"NotFound_btnContainer__kxqeB","loading":"NotFound_loading__n5bB5"};